module.exports = __webpack_public_path__ + "img/marker--party-face.f4ce074.svg";